module.exports = "https://coursera_assets.s3.amazonaws.com/images/fedc02525d7e04e6bbdb4260c2ac3f02.png";